import { useEffect, useState } from "react";

import { useAppDispatch, useAppSelector } from "../../../lib/redux/hooks";
import { Layout } from "../../../ui/layout";
import { MenuItems } from "../../../ui/organisms/navbar/dto";
import Button from "../../../ui/molecules/button";
import { formatterDate, IVActivityTypeOptionsCodes, IVTypeOptions, optionsFormatter, OptionType, PACVisitingModeOptions, tipoAttivitaOptionsCodes } from "../../../utils";
import { AssignmentsListReport } from "./listAssignments";
import { GetAllInspectionVisit } from "../../incarichi/slice";
import { handlePeriodicity } from "../../gestioneControllo/pac/utils";

export function IncProformaDetails() {
    const dispatch = useAppDispatch()
    const reimbursementState = useAppSelector(state => state.reimbursement)
    const assignmentState = useAppSelector(state => state.assignment)
    useEffect(() => {
        dispatch(GetAllInspectionVisit({
            itemsPerPage: 0,
            page: 0,
            assignmentId: reimbursementState.incProformaId
        }))
    }, [])

    return (
        <Layout menuItem={MenuItems.USERS} breadcrumbItems={['Dashboard', 'Gestione Amministrazione', 'Gestione Personale - Contabile']}
            noPaddingLat
            headerLabel="Gestione Personale - Contabile"
            headerChildren={
                <div className="flex items-center h-[100%] w-[100%] justify-end" style={{ justifyContent: 'end' }}>
                    <Button size={"sm"} iconPosition={"off"} variant={"solid"} label="Crea nuovo" color={"orange"}
                        onClick={() => {

                        }}
                    />
                </div>
            }
        >
            {/* FILTERS */}
            <div className="flex flex-col gap-[16px] filter" style={{ padding: '24px 24px 0px 24px' }}>
                <div>

                    <table id="users-table" className="w-[100%]">
                        <thead className="h-[40px] uppercase">
                            <tr>
                                <th style={{ borderTopLeftRadius: '8px' }}>Operazioni</th>
                                <th>Verfifica <br />Amministrativa</th>
                                <th className="width-[150px]">Cliente</th>
                                <th className="width-[70px]">Codice</th>
                                <th className="width-[130px]">Attività</th>
                                <th className="width-[130px]">Data <br /> Visita</th>
                                <th className="width-[130px]">Prelievo</th>
                                <th className="width-[130px]">Mirata</th>
                                <th className="width-[130px]">Tipo Controllo</th>
                                <th className="width-[130px]">Modalità Controllo</th>
                                <th className="width-[130px]">Dettagli Controllo</th>
                                <th className="width-[130px]">Espletata</th>
                                <th className="width-[70px]">Stato</th>
                                <th className="width-[70px]">Verifica Amministrativa</th>
                                <th className="width-[130px]">Verifica<br /> Visita</th>
                                <th className="width-[130px]" style={{ borderTopRightRadius: '8px', width: '40px' }}>Costo Visita</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                assignmentState.getAllInspectionVisitResponse?.data.map((iv, index) =>
                                    <tr
                                        key={index}
                                        style={{
                                            color: '#4D797F',
                                            background: index % 2 === 0 ? '#F2F7F7' : '#FFFFFF'
                                        }}
                                    >
                                        <td>
                                            <div style={{ display: 'flex', gap: '6px' }}>

                                            </div>
                                        </td>
                                        <td>{iv.customerCompanyName}</td>
                                        <td>{iv.customerClientCode}</td>
                                        <td>
                                            {optionsFormatter(iv.activity, tipoAttivitaOptionsCodes)!} {
                                                iv.activityTypes.map((actType) => {
                                                    return <span key={actType}>{optionsFormatter(actType, IVActivityTypeOptionsCodes)!} </span>;
                                                })
                                            }
                                        </td>
                                        <td>
                                            {/* {optionsFormatter(iv.activityTypes, IVActivityTypeOptionsCodes)!} */}
                                        </td>
                                        <td>{formatterDate(iv.effectiveVisitDate)}</td>
                                        <td>
                                            {optionsFormatter(iv.type, IVTypeOptions)!}
                                        </td>
                                        <td>
                                            {optionsFormatter(iv.mode, PACVisitingModeOptions)!}
                                        </td>
                                        <td>{iv.annualControlPlaneDetailPeriodicity && handlePeriodicity(iv.annualControlPlaneDetailPeriodicity)}</td>
                                        <td>{formatterDate(iv.expirationDate)}</td>
                                        <td>{formatterDate(iv.expirationDateExtended)}</td>
                                        <td>espletata</td>
                                        <td>stato</td>
                                        <td>ver amm</td>
                                        <td>verifica visita</td>
                                        <td>costo visita</td>
                                    </tr>
                                )}
                        </tbody>
                    </table>


                </div>
            </div>

        </Layout>
    )
}